import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthContextWrapper } from "./contextAPI's/authContext";
import { Provider } from "react-redux";
import store from "./redux/store";
import { ThemeProvider } from "@mui/material";
import { buildMuiTheme } from "./Components/Theme/muiTheme";
import { fontFamily } from "./Components/Theme";
import { brand, brandKey } from "./brand";

document.title = brand.title;

if (brandKey === "tlscare") {
  // Self-hosted fonts (no third-party requests), loaded for TLScare only.
  import("@fontsource/inter/400");
  import("@fontsource/inter/500");
  import("@fontsource/inter/600");
  import("@fontsource/plus-jakarta-sans/700");
  import("@fontsource/plus-jakarta-sans/800");
  document.body.style.fontFamily = fontFamily();
}

const theme = buildMuiTheme(brandKey);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <BrowserRouter>
        <AuthContextWrapper>
          <App />
        </AuthContextWrapper>
      </BrowserRouter>
    </Provider>
  </ThemeProvider>
  // </React.StrictMode>
);
